var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddddii_426_35529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.99805,
    y: 9,
    width: 59.0001,
    height: 59,
    rx: 29.5,
    fill: "url(#paint0_linear_426_35529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7599 28.3161C46.7269 27.3983 44.5761 26.7462 42.3645 26.377C42.089 26.8575 41.7671 27.5038 41.5451 28.018C39.1606 27.6721 36.7979 27.6721 34.4572 28.018C34.2353 27.5039 33.9062 26.8575 33.6282 26.377C31.4143 26.7463 29.2617 27.4001 27.2278 28.3208C23.1803 34.222 22.0831 39.9764 22.6317 45.6495C25.3162 47.5836 27.9178 48.7586 30.4755 49.5275C31.1112 48.6841 31.6731 47.7912 32.1554 46.858C31.2371 46.5207 30.3518 46.105 29.51 45.6158C29.7315 45.4574 29.9478 45.2923 30.1586 45.1208C35.2593 47.4226 40.8015 47.4226 45.8414 45.1208C46.0531 45.2912 46.2693 45.4562 46.4899 45.6158C45.6468 46.1062 44.7598 46.5228 43.8396 46.8604C44.3247 47.7974 44.8856 48.6912 45.5196 49.5299C48.0797 48.7611 50.6837 47.5861 53.3682 45.6495C54.012 39.0731 52.2687 33.3715 48.7599 28.3161ZM32.8504 42.1607C31.3192 42.1607 30.0634 40.7814 30.0634 39.1019C30.0634 37.4225 31.2924 36.0409 32.8504 36.0409C34.4085 36.0409 35.6641 37.42 35.6374 39.1019C35.6398 40.7814 34.4085 42.1607 32.8504 42.1607ZM43.1495 42.1607C41.6183 42.1607 40.3627 40.7814 40.3627 39.1019C40.3627 37.4225 41.5915 36.0409 43.1495 36.0409C44.7076 36.0409 45.9632 37.42 45.9365 39.1019C45.9365 40.7814 44.7076 42.1607 43.1495 42.1607Z",
    fill: "#F6FFFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddddii_426_35529",
    x: -0.00195312,
    y: 0,
    width: 79,
    height: 79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.439216 0 0 0 0 0.443137 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_426_35529"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.745098 0 0 0 0 0.756863 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_426_35529",
    result: "effect2_dropShadow_426_35529"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.439216 0 0 0 0 0.443137 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_426_35529",
    result: "effect3_dropShadow_426_35529"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.439216 0 0 0 0 0.443137 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_426_35529",
    result: "effect4_dropShadow_426_35529"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_426_35529",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.439216 0 0 0 0 0.443137 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect5_innerShadow_426_35529"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.745098 0 0 0 0 0.756863 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_innerShadow_426_35529",
    result: "effect6_innerShadow_426_35529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_426_35529",
    x1: 8.99805,
    y1: 9,
    x2: 67.998,
    y2: 68.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#158F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179FA1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.0f2e49dbe29f5ebb4046b529f4ee3790.svg";
export { ForwardRef as ReactComponent };